module.exports = __webpack_public_path__ + "static/media/flowers_video_featured.013aa47c.jpg";